import { render, staticRenderFns } from "./ProductShow.vue?vue&type=template&id=780990b5&lang=pug&"
import script from "./ProductShow.vue?vue&type=script&lang=js&"
export * from "./ProductShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductShow.vue?vue&type=style&index=0&id=780990b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports